export default "__VITE_ASSET__bb3a23ec__"